"use client";

import React from "react";
import LogoutButton from "./LogoutButton";
import { useAuth } from "@/providers/AuthProvider";
import Link from "next/link";

const Navbar = () => {
  const { session } = useAuth();

  return (
    <nav className="w-full flex justify-between items-center border-b border-b-foreground/10 px-4 sm:px-6">
      <div className="flex items-center">
        <Link
          href="/"
          className="p-2 sm:p-4 cursor-pointer hover:bg-slate-100 font-bold"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path d="m11.906 46.43c-1.7852 1.4883-4.168 0.89453-5.0586-1.1914-1.1914-2.082-0.59375-4.7617 1.1914-5.9531l40.18-30.355c1.1914-0.89453 2.6797-0.89453 3.8672 0l40.18 30.355c1.4883 1.1914 2.082 3.8672 0.89453 5.9531-0.89453 2.082-3.2734 2.6797-5.0586 1.1914l-38.094-28.867-38.094 28.867z" />
              <path
                d="m83.633 48.809v37.5c0 2.9766-2.3828 5.6562-5.6562 5.6562h-15.773v-28.57c0-2.9766-2.3828-5.0586-5.0586-5.0586h-13.988c-2.9766 0-5.0586 2.082-5.0586 5.0586v28.57h-16.07c-2.9766 0-5.6562-2.6797-5.6562-5.6562v-37.5l33.633-25.297 33.633 25.297z"
                fillRule="evenodd"
              />
            </g>
          </svg>
        </Link>

        {session && (
          <div className="hidden sm:flex gap-4">
            <Link
              href="/files"
              className="p-2 sm:p-4 hover:bg-slate-100 font-bold"
            >
              Files
            </Link>
            <Link
              href="/chat"
              className="p-2 sm:p-4 hover:bg-slate-100 font-bold"
            >
              Chat
            </Link>
          </div>
        )}
      </div>

      {/* User Profile & Logout */}
      <div className="flex items-center gap-4">
        {session ? (
          <>
            <div className="hidden sm:block">Hey, {session?.user?.email}!</div>
            <LogoutButton/>
            <Link
              href="/profile"
              className="p-2 sm:p-4 hover:bg-slate-100 font-bold"
            >
              Profile
            </Link>
          </>
        ) : (
          <Link
            href="/login"
            className="p-2 sm:p-4 rounded-md no-underline bg-btn-background hover:bg-btn-background-hover"
          >
            Login
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
